module.exports = __webpack_public_path__ + "static/olivia-wilde-2a3b9d393c6f1b6a63bb62861c76d104.jpg";